import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

// json hosted outside the app: { "min_version": "1.2.0", "ios_url": "https://apps.apple.com/...", "android_url": "https://play.google.com/..." }
const VERSION_URL = process.env.REACT_APP_VERSION_URL;

// "1.0" < "1.0.1" < "1.2"
export const isOlder = (version, min) => {
    const a = version.split('.').map(Number), b = min.split('.').map(Number);
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
        if ((a[i] || 0) !== (b[i] || 0)) return (a[i] || 0) < (b[i] || 0);
    }
    return false;
};

// store url when the installed version is below min_version, null otherwise
// (also when the file is missing or unreachable: a network error must never lock the app)
export async function checkForcedUpdate() {
    if (!VERSION_URL) return null;
    try {
        const config = await (await fetch(VERSION_URL, { cache: 'no-store' })).json();
        const { version } = await App.getInfo();
        return config?.min_version && isOlder(version, config.min_version) ? (config[`${Capacitor.getPlatform()}_url`] || '') : null;
    } catch {
        return null;
    }
}
